import { render, staticRenderFns } from "./Vendas.vue?vue&type=template&id=1a98d5b4&scoped=true"
import script from "./Vendas.vue?vue&type=script&lang=js"
export * from "./Vendas.vue?vue&type=script&lang=js"
import style0 from "./Vendas.vue?vue&type=style&index=0&id=1a98d5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98d5b4",
  null
  
)

export default component.exports